import { useMemo } from "react"

import { Row } from "antd"

import "./BalanceProgress.less"

const calcMinimalZoneProgress = (minZoneEdge, currentValue) => {
  if (currentValue <= 0) return 0
  if (currentValue > minZoneEdge) return 100
  return Math.round((currentValue / minZoneEdge) * 100)
}

const calcRecommendedZoneProgress = (minZoneEdge, recommendedZoneEdge, currentValue) => {
  if (currentValue < minZoneEdge || currentValue <= 0) return 0
  if (currentValue > recommendedZoneEdge) return 100
  return Math.round(((currentValue - minZoneEdge) / (recommendedZoneEdge - minZoneEdge)) * 100)
}

const calcMaxZoneProgress = (minZoneEdge, recommendedZoneEdge, currentValue) => {
  if (currentValue <= recommendedZoneEdge || recommendedZoneEdge < minZoneEdge) return 0
  const maxEdge = recommendedZoneEdge * 1.5
  if (currentValue >= maxEdge) return 100
  return Math.round(((currentValue - recommendedZoneEdge) / (maxEdge - recommendedZoneEdge)) * 100)
}

const BalanceProgress = ({ min, recommended, current, variant }) => {
  const minimalZoneProgress = calcMinimalZoneProgress(min, current)
  const recommendedZoneProgress = calcRecommendedZoneProgress(min, recommended, current)
  const maxZoneProgress = calcMaxZoneProgress(min, recommended, current)

  const progressColor = useMemo(() => {
    if (variant === "neutral") return "#225AEA"
    if (current < min) return "#D71313"
    return "#225AEA"
  }, [current, min, variant])

  return (
    <Row className="balance-progress">
      <div className="minimal-bar">
        <div
          className="progress"
          style={{
            backgroundColor: progressColor,
            width: minimalZoneProgress + "%"
          }}
        ></div>
      </div>
      <div className="recommended-bar">
        <div
          className="progress"
          style={{
            backgroundColor: progressColor,
            width: recommendedZoneProgress + "%"
          }}
        ></div>
      </div>
      <div className="max-bar">
        <div
          className="progress"
          style={{
            backgroundColor: progressColor,
            width: maxZoneProgress + "%"
          }}
        ></div>
      </div>
    </Row>
  )
}

export default BalanceProgress
